/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import PageConfig from '@msr/Common/PageConfig';
import RenderSections from '@msr/Common/RenderSections';
import WrapLayout from '@msr/components/Layout/WrapLayout';
import Breadcrum from '@msr/components/Navigation/Breadcrum';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@msr/components/Utility/Shared/SharedService';
import {
    fetchFooterDetailData,
    fetchHeaderMenuData
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/msrService';

/**
 * @param {string} pageData - MahaShivratri PAQ Page Data
 */
const MahaShivratriFaqLang = ({ pageData, lang }) => {
  
  const authContext = useContext(AuthContext);
  let currRegion = {};

  useEffect(() => {
    authContext.RegionAndLang('', lang);
  }, [authContext, lang]);

  return (
    <WrapLayout pageData={pageData}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url=""
        region={''}
        lang={lang}
      />

      <Box
        as="section"
        className="container"
        px="0"
        bg="#FFF7E9"
        color="black"
      >
        {pageData?.body?.length && pageData?.body[0]?.value.length
          ? pageData.body[0]?.value.map((section, i) => {
              return (
                <RenderSections pageData={pageData}
                  section={section}
                  region={''}
                  lang={lang}
                  key={nanoid(4)}
                />
              );
            })
          : null}
      </Box>
      <PageConfig
        isLikeVisible={false} pageData={pageData}
      />
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const msrPaths = config.USE_LOCAL_URL
    ? [
        `/mahashivratri/ta/faq`
      ]
    : await getLandingPaths('L1', '/faq');
  return {
    paths: msrPaths,
    fallback: false
  };
};

export const getStaticProps = async ({
  preview, previewData,
  params: { lang }
}) => {
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('', lang, 'msr'),
    'msrmainmenu'
  );
  const footerData = await fetchFooterDetailData(
    getLocale('', lang, 'msr'),
    'msrfooter'
  );
  const pageData = await fetchDetails('', lang, 'faq', {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerMenuData: headerMenuData?.data || null,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      lang: lang,
      menuType: 'msrmainmenu'
    },
  };
};

export default MahaShivratriFaqLang;
